import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PAGINAS, ROUTES, FUNCIONALIDADES } from '../../../routes';
import { getPerfisLaborais } from './perfis_laboraris.service';
import GridBase from '../../../components/grid_base';
export var PerfisLaboraisListar = function () {
    var COLUNAS_FUNCIONALIDADE = [
        { field: 'nome', headerName: 'Nome', width: 500 },
        { field: 'situacao', headerName: 'Situação', width: 150 },
    ];
    return (_jsx(GridBase, { pagina: PAGINAS.PERFIS_LABORAIS, paginaPermissao: FUNCIONALIDADES.PERFIS_LABORAIS, rota: ROUTES.PERFIS_LABORAIS, columns: COLUNAS_FUNCIONALIDADE, fetchData: function (str, _, pag) { return getPerfisLaborais(str, pag); } }));
};
export default PerfisLaboraisListar;
